import React, { useCallback, useMemo } from 'react';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import clsx from 'clsx';
import { connect } from 'react-redux';

import styles from '../styles/datacardActions';
import { actions as swapSimcardReduxActions } from '../../swapSimcard/reducers';
import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import LockNumber from '../../../partials/lockNumber/LockNumber';
import {
  doesArrayHasLength,
  isDefined,
  isUndefined
} from '../../../utils/isDefined';
import withUserCheck from '../../../utils/withUserCheck';
import ShowQrCode from '../../../partials/showQrCode/ShowQrCode';
import Optional from '../../../utils/optional';
import can from '../../../utils/can';
import createSubject from '../../../utils/createSubject';
import DataCheckboxRow from '../../../partials/dataBox/DataCheckboxRow';
import { translate } from '../../../i18n/I18nProvider';
import { CAN_SWAP_STATUSES } from '../../../consts/initialValues';
import checkShouldShowQRCode from '../../../utils/checkShouldShowQRCode';

const DatacardActions = ({
  classes,
  form,
  openSwapSimcard,
  simcard = {},
  activationCode,
  isESimCard,
  hasClientAccounts,
  isLoading,
  subscription,
  isIoTCard
}) => {
  const onSwapClick = useCallback(
    () => {
      const { id, msisdn, mobile_network, client_id } = simcard;
      openSwapSimcard({
        simcard: { id, msisdn, mobile_network, client_id, isESimCard },
        fromEdit: true,
        problems: subscription?.problems,
        isIoTCard
      });
    },
    // eslint-disable-next-line
    [simcard, isIoTCard, subscription?.problems]
  );

  const shouldShowQRCode = useMemo(
    () =>
      checkShouldShowQRCode({
        subscription,
        hasClientAccounts,
        isESimCard,
        activationCode
      }),
    [subscription, hasClientAccounts, isESimCard, activationCode]
  );

  return (
    <div
      className={clsx(classes.root, {
        [classes.withoutMsisdn]:
          isUndefined(simcard.msisdn) ||
          simcard?.mobile_network?.brand !== 'TDC'
      })}
    >
      <div className={classes.datacard}>
        {!isIoTCard ? (
          <DataCheckboxRow
            label={translate('DATACARD')}
            name="data_card"
            disabled={true}
            width={140}
            {...form}
          />
        ) : (
          <div className={classes.noDatacardCheckboxContainer}></div>
        )}
      </div>
      {shouldShowQRCode && (
        <ShowQrCode
          activationCode={activationCode}
          icc={simcard?.icc}
          number={simcard.msisdn}
          subStatus={subscription?.status}
        >
          <PrimaryButton>
            {translate('SWAP_SIMCARD.SHOW_QR_CODE')}
          </PrimaryButton>
        </ShowQrCode>
      )}
      <div className={classes.buttons}>
        {isDefined(simcard.msisdn) &&
          simcard?.mobile_network?.brand === 'TDC' &&
          can('swap', createSubject('SimCard', simcard)) && (
            <div>
              <PrimaryButton
                tooltipOnDisabled={
                  CAN_SWAP_STATUSES.includes(subscription?.status)
                    ? ''
                    : translate(
                        'SWAP_SIMCARD.TOOLTIP_DISABLED_WHEN_NOT_ACTIVE_OR_TERMINATED'
                      )
                }
                onClick={onSwapClick}
                disabled={
                  isUndefined(subscription?.id) ||
                  isLoading ||
                  !CAN_SWAP_STATUSES.includes(subscription?.status)
                }
              >
                {translate('BUTTON.SWAP_SIMCARD')}
              </PrimaryButton>
            </div>
          )}
        {isDefined(simcard.msisdn) &&
          isDefined(simcard.active) &&
          simcard?.mobile_network?.brand === 'TDC' && (
            <LockNumber
              tooltipOnDisabled={
                !CAN_SWAP_STATUSES.includes(subscription?.status)
                  ? translate('TOOLTIP_DISABLED_WHEN_NOT_ACTIVE')
                  : ''
              }
              data={simcard}
              fromTable={true}
              disabled={!CAN_SWAP_STATUSES.includes(subscription?.status)}
            />
          )}
      </div>
    </div>
  );
};

const mapStatesToProps = ({ editSimcard, selectClient, loader }) => {
  return {
    ...editSimcard,
    hasClientAccounts: Optional(
      selectClient.selectedClient?.metadata?.account_ids
    )
      .map(accounts => doesArrayHasLength(accounts))
      .or(false),
    isLoading: loader.isLinearVisible
  };
};

const mapDispatchToProps = {
  openSwapSimcard: swapSimcardReduxActions.openDialog
};

export default flowRight(
  withUserCheck,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(DatacardActions);
